export enum ReportsServiceTag {
  BackupStatus = 'BackupStatus',
  LastBackupDate = 'LastBackupDate',
  Service = 'Service',
  ServiceStatus = 'ServiceStatus',
  Size = 'Size'
}

export const ReportsServiceTagsMap = new Map<ReportsServiceTag, { tag: string; prop: string }>([
  [ReportsServiceTag.Service, { tag: 'Service', prop: 'Service' }],
  [ReportsServiceTag.ServiceStatus, { tag: 'Service status', prop: 'ServiceStatus' }],
  [ReportsServiceTag.LastBackupDate, { tag: 'Last backup date', prop: 'LastBackupDate' }],
  [ReportsServiceTag.Size, { tag: 'Size', prop: 'Size' }],
  [ReportsServiceTag.BackupStatus, { tag: 'Backup status', prop: 'BackupStatus' }]
]);

export enum ReportsUserTag {
  Calendar = 'Calendar',
  Contacts = 'Contacts',
  Drive = 'Drive',
  License = 'License',
  Mail = 'Mail',
  UserName = 'UserName',
  UserState = 'UserState'
}

export const ReportsUserTagsMap = new Map<ReportsUserTag, { tag: string; prop: string }>([
  [ReportsUserTag.UserName, { tag: 'User name', prop: 'UserName' }],
  [ReportsUserTag.License, { tag: 'License', prop: 'ExpireDate' }],
  [ReportsUserTag.UserState, { tag: 'User', prop: 'InBackup' }],
  [ReportsUserTag.Mail, { tag: 'Mail', prop: 'Mail' }],
  [ReportsUserTag.Drive, { tag: 'Drive', prop: 'Drive' }],
  [ReportsUserTag.Contacts, { tag: 'Contacts', prop: 'Contacts' }],
  [ReportsUserTag.Calendar, { tag: 'Calendar', prop: 'Calendar' }]
]);
